import { FormItem } from '@faceup/ui'
import {
  TreeSelect as AntTreeSelect,
  type TreeSelectProps as AntTreeSelectProps,
} from '@faceup/ui-base'
import type { FieldValues, UseControllerProps } from 'react-hook-form'
import { useCustomController } from '../hooks'
import type { FormItemWrapperProps } from '../typings'

export type TreeSelectProps<T extends FieldValues, V = string> = {
  onChange?: (value: V) => void
} & UseControllerProps<T> &
  Omit<AntTreeSelectProps<V> & FormItemWrapperProps, 'value' | 'defaultValue' | 'onChange'>

export const TreeSelect = <T extends FieldValues, V>(props: TreeSelectProps<T, V>) => {
  const {
    formItemProps,
    inputProps: { onChange: fieldOnChange, value, ...inputProps },
  } = useCustomController(props)

  return (
    <FormItem {...formItemProps}>
      <AntTreeSelect
        {...inputProps}
        styles={{
          dropdown: {
            zIndex: '1100!important',
          },
        }}
        value={value ?? null}
        onChange={value => {
          fieldOnChange(value ?? null)
          props.onChange?.(value as V)
        }}
      />
    </FormItem>
  )
}
